module.exports = __webpack_public_path__ + "img/test_icon_ccss.6c67fda9.svg";